<template>
  <div class="mb-1">
    <div class="row">
      <div class="col-6">
        <h2 class="generalTitle">Estadísticas</h2>
      </div>
      <div class="col-6">
        <h2 class="d-flex align-self-end justify-content-end generalTitle">
          <div
            v-if="loadingDataFilter || errorAPI !== '' || noDataFilter !== ''"
          >
            &nbsp;
          </div>
          <div
            v-if="
              !loadingDataFilter &&
              errorAPI == '' &&
              noDataFilter === '' &&
              loadingDownload
            "
            style="color: green"
          >
            Descargando Excel...
          </div>
          <a
            v-if="
              !loadingDataFilter &&
              errorAPI == '' &&
              noDataFilter === '' &&
              !loadingDownload
            "
            class="d-flex align-self-end justify-content-end"
            href="#"
            @click="exportToExcel"
          >
            <v-icon name="bi-download" scale="1.1" /> DESCARGAR EXCEL
          </a>
        </h2>
      </div>
    </div>
    <div v-if="errorAPI !== ''" class="text-center pt-4 pb-4">
      <div class="text-center mb-4 mt-1">
        <v-icon name="hi-x-circle" scale="5" fill="red" />
      </div>
      <div>
        <h3 class="text-center mb-4 mt-1">{{ errorAPI }}</h3>
      </div>
    </div>
    <div v-else>
      <div v-if="loadingDataOrigin" class="text-center pt-4 pb-4">
        <img src="@/assets/loaderPrimary.svg" height="200" alt="" />
      </div>
      <div v-if="!loadingDataOrigin" class="row mb-1">
        <div class="col-sm-12 col-md-6 col-lg-3 mb-2">
          <TotalSales
            :name="netSellLabel"
            :quantity="totalNetSell"
            :loading="loadingDataFilter"
          ></TotalSales>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3 mb-2">
          <TotalSales
            :name="grossSellLabel"
            :quantity="totalGrossSell"
            :loading="loadingDataFilter"
          ></TotalSales>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 mb-2">
          <div class="row">
            <div class="col-6 col-md-6">
              <div class="form-group">
                <label class="generalLabel" for="startDate">Desde</label>
                <DatePicker
                  v-model="startDate"
                  mode="date"
                  :model-config="modelConfig"
                  :minDate="minDateStart"
                  :maxDate="maxDateStart"
                >
                  <template v-slot="{ togglePopover }">
                    <input
                      @click="togglePopover()"
                      class="form-control bg-white generalInput"
                      readonly
                      v-model="startDate"
                    />
                    <v-icon
                      name="ri-calendar-line"
                      scale="0.9"
                      class="generalSelect__iconDate"
                      @click="togglePopover()"
                    />
                  </template>
                </DatePicker>
              </div>
            </div>
            <div class="col-6 col-md-6">
              <div class="form-group">
                <label class="generalLabel" for="endDate">Hasta</label>
                <DatePicker
                  v-model="endDate"
                  mode="date"
                  :model-config="modelConfig"
                  :minDate="minDateEnd"
                  :maxDate="maxDateEnd"
                >
                  <template v-slot="{ togglePopover }">
                    <input
                      @click="togglePopover()"
                      class="form-control bg-white generalInput"
                      readonly
                      v-model="endDate"
                    />
                    <v-icon
                      name="ri-calendar-line"
                      scale="0.9"
                      class="generalSelect__iconDate"
                      @click="togglePopover()"
                    />
                  </template>
                </DatePicker>
              </div>
            </div>
            <div
              class="col-12 col-md-12 d-flex align-self-end justify-content-end"
            >
              <div class="form-group d-flex">
                <button
                  class="btn generalSecondaryButton mr-2"
                  style="margin: 0 !important; margin-right: 30px !important"
                  @click="clearDates"
                  :disabled="
                    loadingDataFilter || (startDate === '' && endDate === '')
                  "
                >
                  Limpiar
                </button>
                <button
                  class="btn btn-primary generalPrimaryButton align-items-center"
                  style="margin: 0 !important"
                  @click="applyFilters"
                  :disabled="
                    loadingDataFilter || (startDate === '' && endDate === '')
                  "
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 mb-2 d-flex justify-content-center"
        v-if="loadingDataFilter && !loadingDataOrigin"
      >
        <img src="@/assets/loaderPrimary.svg" height="200" alt="" />
      </div>
      <div
        v-if="!loadingDataFilter && noDataFilter !== ''"
        class="text-center pt-4 pb-4"
      >
        <div class="text-center mb-4 mt-1">
          <v-icon name="hi-x-circle" scale="3" fill="red" />
        </div>
        <div>
          <h3 class="text-center mb-4 mt-1">{{ noDataFilter }}</h3>
        </div>
      </div>
      <div v-if="!loadingDataFilter && noDataFilter === ''" class="row">
        <div class="col-12">
          <Chart
            class="mb-3"
            :type="chartDatas.days.type"
            :title="chartDatas.days.title"
            :labels="chartDatas.days.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.days.netSellData"
            :data2="chartDatas.days.grossSellData"
            :barThickness="chartDatas.days.barThickness"
          ></Chart>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-5">
          <Chart
            class="mb-3"
            :type="chartDatas.weeks.type"
            :title="chartDatas.weeks.title"
            :labels="chartDatas.weeks.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.weeks.netSellData"
            :data2="chartDatas.weeks.grossSellData"
            :barThickness="chartDatas.weeks.barThickness"
          ></Chart>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-7">
          <Chart
            class="mb-3"
            :type="chartDatas.months.type"
            :title="chartDatas.months.title"
            :labels="chartDatas.months.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.months.netSellData"
            :data2="chartDatas.months.grossSellData"
            :barThickness="chartDatas.months.barThickness"
          ></Chart>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4">
          <Chart
            class="mb-3"
            :type="chartDatas.quaters.type"
            :title="chartDatas.quaters.title"
            :labels="chartDatas.quaters.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.quaters.netSellData"
            :data2="chartDatas.quaters.grossSellData"
            :barThickness="chartDatas.quaters.barThickness"
          ></Chart>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4">
          <Chart
            class="mb-3"
            :type="chartDatas.semesters.type"
            :title="chartDatas.semesters.title"
            :labels="chartDatas.semesters.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.semesters.netSellData"
            :data2="chartDatas.semesters.grossSellData"
            :barThickness="chartDatas.semesters.barThickness"
          ></Chart>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4">
          <Chart
            class="mb-3"
            :type="chartDatas.years.type"
            :title="chartDatas.years.title"
            :labels="chartDatas.years.labels"
            :label1="netSellLabel"
            :label2="grossSellLabel"
            :data1="chartDatas.years.netSellData"
            :data2="chartDatas.years.grossSellData"
            :barThickness="chartDatas.years.barThickness"
          ></Chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "./components/Chart.vue";
import TotalSales from "./components/TotalSales.vue";
import { DatePicker } from "v-calendar";
import moment from "moment";
import ExcelJS from "exceljs";
import axios from "axios";
import { NET_SELL_LABEL, GROSS_SELL_LABEL } from "./constants";
export default {
  name: "StatsList",
  components: {
    Chart,
    TotalSales,
    DatePicker,
  },
  data() {
    return {
      loadingDataOrigin: true,
      loadingDataFilter: true,
      loadingDownload: false,
      dataOrigin: [],
      errorAPI: "",
      noDataFilter: "",
      netSellLabel: NET_SELL_LABEL,
      grossSellLabel: GROSS_SELL_LABEL,
      totalNetSell: 0,
      totalGrossSell: 0,
      more2YearSelected: false,
      startDate: "",
      endDate: "",
      modelConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      minDateData: "",
      maxDateData: "",
      minDateStart: "",
      maxDateStart: "",
      minDateEnd: "",
      maxDateEnd: "",
      chartDatas: {
        days: {
          title: "Diario",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
        weeks: {
          title: "Semanal",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
        months: {
          title: "Mensual",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
        quaters: {
          title: "Cuatrimestral",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
        semesters: {
          title: "Semestral",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
        years: {
          title: "Anual",
          type: "bar",
          labels: [],
          netSellData: [],
          grossSellData: [],
          barThickness: 8,
        },
      },
    };
  },
  created() {
    this.getDataOrigin();
  },
  watch: {
    startDate(newStartDate) {
      if (newStartDate === "") {
        this.minDateEnd = this.minDateData;
      } else {
        this.minDateEnd = moment(newStartDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
      }
    },
    endDate(newEndDate) {
      if (newEndDate === "") {
        this.maxDateStart = this.maxDateData;
      } else {
        this.maxDateStart = moment(newEndDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
      }
    },
  },
  methods: {
    clearDates() {
      this.startDate = "";
      this.endDate = "";
      this.$nextTick(() => {
        this.applyFilters();
      });
    },
    applyFilters() {
      this.loadingDataFilter = true;
      this.noDataFilter = "";
      let dataFilter = [];
      let totalNetSell = 0;
      let totalGrossSell = 0;
      let daysLabels = [];
      let daysNetSellData = [];
      let daysGrossSellData = [];
      let weeksLabels = [];
      let weeksNetSellData = [];
      let weeksGrossSellData = [];
      let monthsLabels = [];
      let monthsNetSellData = [];
      let monthsGrossSellData = [];
      let quatersLabels = [];
      let quatersNetSellData = [];
      let quatersGrossSellData = [];
      let semestersLabels = [];
      let semestersNetSellData = [];
      let semestersGrossSellData = [];
      let yearsLabels = [];
      let yearsNetSellData = [];
      let yearsGrossSellData = [];

      const datePersonalized = this.startDate !== "" || this.endDate !== "";
      const today = moment();
      const firstDayMonth = today.clone().startOf("month");
      const lastDayMonth = today.clone().endOf("month");
      const firstDayMonthMonday = firstDayMonth
        .clone()
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
      const firstDayYear = today.clone().startOf("year");
      const lastDayYear = today.clone().endOf("year");

      let firstDayDataFilter = moment(this.dataOrigin[0].date, "YYYY-MM-DD");
      let lastDayDataFilter = moment(
        this.dataOrigin[this.dataOrigin.length - 1].date,
        "YYYY-MM-DD"
      );

      if (this.startDate !== "") {
        firstDayDataFilter = moment(this.startDate, "DD/MM/YYYY");
      }
      if (this.endDate !== "") {
        lastDayDataFilter = moment(this.endDate, "DD/MM/YYYY");
      }

      dataFilter = this.dataOrigin.filter((item) => {
        const currentDate = moment(item.date, "YYYY-MM-DD");
        return currentDate.isBetween(
          firstDayDataFilter,
          lastDayDataFilter,
          null,
          "[]"
        );
      });

      if (dataFilter.length === 0) {
        this.noDataFilter = "No hay datos para las fechas seleccionadas.";
      } else {
        if (
          datePersonalized &&
          firstDayDataFilter.format("YYYY") != lastDayDataFilter.format("YYYY")
        ) {
          this.more2YearSelected = true;
        } else {
          this.more2YearSelected = false;
        }

        dataFilter.forEach((item) => {
          const currentDate = moment(item.date, "YYYY-MM-DD");
          totalNetSell += item.netSell;
          totalGrossSell += item.grossSell;

          // sacar datos para la gráfica diaria en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son del mes en curso)
          if (datePersonalized) {
            daysLabels.push(item.date);
            daysNetSellData.push(item.netSell);
            daysGrossSellData.push(item.grossSell);
          } else if (
            currentDate.isBetween(firstDayMonth, lastDayMonth, null, "[]")
          ) {
            daysLabels.push(item.date);
            daysNetSellData.push(item.netSell);
            daysGrossSellData.push(item.grossSell);
          }
          // sacar datos para la gráfica semanal en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son del mes en curso)
          if (datePersonalized) {
            const index = weeksLabels.indexOf(item.week);
            if (index !== -1) {
              weeksNetSellData[index] += item.netSell;
              weeksGrossSellData[index] += item.grossSell;
            } else {
              weeksLabels.push(item.week);
              weeksNetSellData.push(item.netSell);
              weeksGrossSellData.push(item.grossSell);
            }
          } else if (
            currentDate.isBetween(firstDayMonthMonday, lastDayMonth, null, "[]")
          ) {
            const index = weeksLabels.indexOf(item.week);
            if (index !== -1) {
              weeksNetSellData[index] += item.netSell;
              weeksGrossSellData[index] += item.grossSell;
            } else {
              weeksLabels.push(item.week);
              weeksNetSellData.push(item.netSell);
              weeksGrossSellData.push(item.grossSell);
            }
          }

          // sacar datos para la gráfica mensual en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son del año en curso)
          const monthConvert = `${
            item.month.split("-")[0]
          }-${this.$getMonthName(item.month.split("-")[1] - 1)}`;
          if (datePersonalized) {
            const index = monthsLabels.indexOf(monthConvert);
            if (index !== -1) {
              monthsNetSellData[index] += item.netSell;
              monthsGrossSellData[index] += item.grossSell;
            } else {
              monthsLabels.push(monthConvert);
              monthsNetSellData.push(item.netSell);
              monthsGrossSellData.push(item.grossSell);
            }
          } else if (
            currentDate.isBetween(firstDayYear, lastDayYear, null, "[]")
          ) {
            const index = monthsLabels.indexOf(monthConvert);
            if (index !== -1) {
              monthsNetSellData[index] += item.netSell;
              monthsGrossSellData[index] += item.grossSell;
            } else {
              monthsLabels.push(monthConvert);
              monthsNetSellData.push(item.netSell);
              monthsGrossSellData.push(item.grossSell);
            }
          }

          // sacar datos para la gráfica cuatrimestral en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son del año en curso)
          if (datePersonalized) {
            const index = quatersLabels.indexOf(item.q);
            if (index !== -1) {
              quatersNetSellData[index] += item.netSell;
              quatersGrossSellData[index] += item.grossSell;
            } else {
              quatersLabels.push(item.q);
              quatersNetSellData.push(item.netSell);
              quatersGrossSellData.push(item.grossSell);
            }
          } else if (
            currentDate.isBetween(firstDayYear, lastDayYear, null, "[]")
          ) {
            const index = quatersLabels.indexOf(item.q);
            if (index !== -1) {
              quatersNetSellData[index] += item.netSell;
              quatersGrossSellData[index] += item.grossSell;
            } else {
              quatersLabels.push(item.q);
              quatersNetSellData.push(item.netSell);
              quatersGrossSellData.push(item.grossSell);
            }
          }
          // sacar datos para la gráfica semestral en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son del año en curso)
          if (datePersonalized) {
            const index = semestersLabels.indexOf(item.semester);
            if (index !== -1) {
              semestersNetSellData[index] += item.netSell;
              semestersGrossSellData[index] += item.grossSell;
            } else {
              semestersLabels.push(item.semester);
              semestersNetSellData.push(item.netSell);
              semestersGrossSellData.push(item.grossSell);
            }
          } else if (
            currentDate.isBetween(firstDayYear, lastDayYear, null, "[]")
          ) {
            const index = semestersLabels.indexOf(item.semester);
            if (index !== -1) {
              semestersNetSellData[index] += item.netSell;
              semestersGrossSellData[index] += item.grossSell;
            } else {
              semestersLabels.push(item.semester);
              semestersNetSellData.push(item.netSell);
              semestersGrossSellData.push(item.grossSell);
            }
          }
          // sacar datos para la gráfica anual en función si hay fechas dadas (sino se ha puesto ninguna fecha los datos son de todos los tiempos)
          if (datePersonalized) {
            const index = yearsLabels.indexOf(item.year);
            if (index !== -1) {
              yearsNetSellData[index] += item.netSell;
              yearsGrossSellData[index] += item.grossSell;
            } else {
              yearsLabels.push(item.year);
              yearsNetSellData.push(item.netSell);
              yearsGrossSellData.push(item.grossSell);
            }
          } else {
            const index = yearsLabels.indexOf(item.year);
            if (index !== -1) {
              yearsNetSellData[index] += item.netSell;
              yearsGrossSellData[index] += item.grossSell;
            } else {
              yearsLabels.push(item.year);
              yearsNetSellData.push(item.netSell);
              yearsGrossSellData.push(item.grossSell);
            }
          }
        });
      }

      this.chartDatas.days.labels = daysLabels;
      this.chartDatas.days.netSellData = daysNetSellData;
      this.chartDatas.days.grossSellData = daysGrossSellData;
      let barThickness = 8;
      if (daysLabels.length <= 31) {
        barThickness = 16;
      }
      this.chartDatas.days.barThickness = barThickness;
      

      if (this.more2YearSelected) {
        this.chartDatas.weeks.labels = weeksLabels;
      } else {
        this.chartDatas.weeks.labels = weeksLabels.map(
          (item) => item.split("-")[1]
        );
      }
      this.chartDatas.weeks.netSellData = weeksNetSellData;
      this.chartDatas.weeks.grossSellData = weeksGrossSellData;
      barThickness = 8;
      if (weeksLabels.length <= 20) {
        barThickness = 16;
      }
      this.chartDatas.weeks.barThickness = barThickness;

      if (this.more2YearSelected) {
        this.chartDatas.months.labels = monthsLabels;
      } else {
        this.chartDatas.months.labels = monthsLabels.map(
          (item) => item.split("-")[1]
        );
      }
      this.chartDatas.months.netSellData = monthsNetSellData;
      this.chartDatas.months.grossSellData = monthsGrossSellData;
      barThickness = 8;
      if (monthsLabels.length <= 12) {
        barThickness = 16;
      }
      this.chartDatas.months.barThickness = barThickness;

      if (this.more2YearSelected) {
        this.chartDatas.quaters.labels = quatersLabels;
      } else {
        this.chartDatas.quaters.labels = quatersLabels.map(
          (item) => item.split("-")[1]
        );
      }
      this.chartDatas.quaters.netSellData = quatersNetSellData;
      this.chartDatas.quaters.grossSellData = quatersGrossSellData;
      barThickness = 8;
      if (quatersLabels.length <= 8) {
        barThickness = 16;
      }
      this.chartDatas.quaters.barThickness = barThickness;

      if (this.more2YearSelected) {
        this.chartDatas.semesters.labels = semestersLabels;
      } else {
        this.chartDatas.semesters.labels = semestersLabels.map(
          (item) => item.split("-")[1]
        );
      }
      this.chartDatas.semesters.netSellData = semestersNetSellData;
      this.chartDatas.semesters.grossSellData = semestersGrossSellData;
      barThickness = 8;
      if (semestersLabels.length <= 8) {
        barThickness = 16;
      }
      this.chartDatas.semesters.barThickness = barThickness;

      this.chartDatas.years.labels = yearsLabels;
      this.chartDatas.years.netSellData = yearsNetSellData;
      this.chartDatas.years.grossSellData = yearsGrossSellData;
      this.chartDatas.years.barThickness = 16;
      this.totalNetSell = totalNetSell;
      this.totalGrossSell = totalGrossSell;
      this.$nextTick(() => {
        setTimeout(() => {
          this.loadingDataFilter = false;
        }, 600);
      });
    },
    getDataOrigin() {
      axios
        .post("/sales-information")
        .then((response) => {
          this.dataOrigin = response.data.salesInformation;
          this.minDateData = this.dataOrigin[0].date;
          this.maxDateData = this.dataOrigin[this.dataOrigin.length - 1].date;
          this.minDateStart = this.minDateData;
          this.maxDateStart = this.maxDateData;
          this.minDateEnd = this.minDateData;
          this.maxDateEnd = this.maxDateData;
          this.loadingDataOrigin = false;
          this.$nextTick(() => {
            this.applyFilters();
          });
        })
        .catch(() => {
          this.errorAPI =
            "Ha ocurrido un error en la carga de datos, si el problema persiste contacte con el administrador del sistema.";
          this.$nextTick(() => {
            this.loadingDataOrigin = false;
          });
        });
    },
    exportToExcel() {
      this.loadingDownload = true;
      setTimeout(() => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Stats");
        const header = [
          "FECHA",
          "BRUTAS",
          "NETAS",
          "",
          "SEMANA",
          "BRUTAS",
          "NETAS",
          "",
          "MENSUAL",
          "BRUTAS",
          "NETAS",
          "",
          "CUATRIMESTRE",
          "BRUTAS",
          "NETAS",
          "",
          "SEMESTRE",
          "BRUTAS",
          "NETAS",
          "",
          "AÑO",
          "BRUTAS",
          "NETAS",
        ];
        let data = [];
        data.push(header);

        this.chartDatas.days.labels.forEach((label, index) => {
          let dataTemp = [];

          const objectOrigin = this.dataOrigin.find(
            (item) => item.date === label
          );

          if (objectOrigin) {
            dataTemp.push(label);
            dataTemp.push(objectOrigin.grossSell);
            dataTemp.push(objectOrigin.netSell);
          }
          if (this.chartDatas.weeks.labels[index]) {
            dataTemp.push("");
            dataTemp.push(this.chartDatas.weeks.labels[index]);
            dataTemp.push(this.chartDatas.weeks.grossSellData[index]);
            dataTemp.push(this.chartDatas.weeks.netSellData[index]);
          }
          if (this.chartDatas.months.labels[index]) {
            dataTemp.push("");
            if (!this.chartDatas.weeks.labels[index]) {
              dataTemp.push("", "", "", "");
            }
            if (this.more2YearSelected) {
              dataTemp.push(
                `${
                  this.chartDatas.months.labels[index].split("-")[0]
                }-${this.$getMonthNumber(
                  this.chartDatas.months.labels[index].split("-")[1]
                )}`
              );
            } else {
              dataTemp.push(
                this.$getMonthNumber(this.chartDatas.months.labels[index])
              );
            }

            dataTemp.push(this.chartDatas.months.grossSellData[index]);
            dataTemp.push(this.chartDatas.months.netSellData[index]);
          }
          if (this.chartDatas.quaters.labels[index]) {
            dataTemp.push("");
            if (!this.chartDatas.months.labels[index]) {
              dataTemp.push("", "", "", "");
            }
            dataTemp.push(this.chartDatas.quaters.labels[index]);
            dataTemp.push(this.chartDatas.quaters.grossSellData[index]);
            dataTemp.push(this.chartDatas.quaters.netSellData[index]);
          }
          if (this.chartDatas.semesters.labels[index]) {
            dataTemp.push("");
            if (!this.chartDatas.quaters.labels[index]) {
              dataTemp.push("", "", "", "");
            }
            dataTemp.push(this.chartDatas.semesters.labels[index]);
            dataTemp.push(this.chartDatas.semesters.grossSellData[index]);
            dataTemp.push(this.chartDatas.semesters.netSellData[index]);
          }
          if (this.chartDatas.years.labels[index]) {
            dataTemp.push("");
            if (!this.chartDatas.semesters.labels[index]) {
              dataTemp.push("", "", "", "");
            }
            dataTemp.push(this.chartDatas.years.labels[index]);
            dataTemp.push(this.chartDatas.years.grossSellData[index]);
            dataTemp.push(this.chartDatas.years.netSellData[index]);
          }

          data.push(dataTemp);
        });

        data.forEach((row, rowIndex) => {
          const excelRow = worksheet.addRow(row);

          excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            const columnLetter = worksheet.getColumn(colNumber).letter;
            if (cell.text && cell.text.trim() !== "") {
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
              cell.alignment = { horizontal: "center", vertical: "middle" };
              if (
                [
                  "B",
                  "C",
                  "F",
                  "G",
                  "J",
                  "K",
                  "N",
                  "O",
                  "R",
                  "S",
                  "V",
                  "W",
                ].includes(columnLetter)
              ) {
                if (rowIndex > 0) {
                  cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D9D9D9" },
                  };
                }
              }
            }
          });
        });
        worksheet.columns.forEach((column) => {
          const columnLetter = column.letter;
          if (["D", "H", "L", "P", "T"].includes(columnLetter)) {
            column.width = 2;
          } else if (["M", "Q"].includes(columnLetter)) {
            column.width = 15;
          } else if (["A"].includes(columnLetter)) {
            column.width = 10;
          }
        });
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "stats.xlsx";
          link.click();
          this.loadingDownload = false;
        });
      }, 100);
    },
  },
};
</script>
<style scoped lang="scss"></style>
